import { MenuItem, Stack, TextField } from '@mui/material'
import { EditorField } from './schemaEditorReducer'

interface P {
    field: EditorField
    onUpdateField: (
        fieldId: string,
        updates: Partial<EditorField>
    ) => void
}

const BoolFieldConfig = ({ field, onUpdateField }: P) => {
    return (
        <Stack spacing={2}>

            <TextField
                disabled={field.isDefault}
                select
                fullWidth
                size='small'
                label='Value'
                value={
                    field.validation?.value === undefined
                        ? ''
                        : field.validation.value
                            ? 'true'
                            : 'false'
                }
                onChange={e =>
                    onUpdateField(field._id, {
                        validation: {
                            ...field.validation,
                            value:
                                e.target.value === ''
                                    ? undefined
                                    : e.target.value === 'true'
                        }
                    })}>
                <MenuItem value=''>None</MenuItem>
                <MenuItem value='true'>True</MenuItem>
                <MenuItem value='false'>False</MenuItem>
            </TextField>
            <TextField
                disabled={field.isDefault}
                fullWidth
                size='small'
                label='Description'
                value={field.description ?? ''}
                onChange={e => onUpdateField(field._id,
                    { description: e.target.value === '' ? undefined : e.target.value }
                )}>

            </TextField>

        </Stack>
    )
}

export default BoolFieldConfig
